export default "__VITE_ASSET__CslWLkaF__"